module.exports = __webpack_public_path__ + "img/aeb0c5a.png";